var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn c-btn-default",on:{"click":_vm.emitShowQuestionnaire}},[_vm._v(_vm._s(_vm.button.description))])}
var staticRenderFns = []

export { render, staticRenderFns }